import { Check } from 'lucide-react';

const features = [
  { icon: '🌙', title: 'Noite na Varjota' },
  { icon: '👥', title: 'Encontro entre amigos' },
  { icon: '🎵', title: 'Música boa' },
  { icon: '🍽️', title: 'Comida e Petiscos' },
  { icon: '🏠', title: 'Mesas na Cobertura' },
  { icon: '❄️', title: 'Área Climatizada' },
];

const highlights = [
  'Varjota / Adelote',
  'Culinária baiana e nordestina',
  'Delivery disponível',
  'Ambiente descontraído',
];

export default function AboutSection() {
  return (
    <section id="sobre" className="py-16 md:py-24 bg-cream-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Image */}
            <div className="reveal reveal-left">
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://storage.readdy-site.link/project_files/2d00fbf4-9726-483a-b70b-ea6e421eb3f8/44c26636-5869-4a38-9f8d-fbc0909be5f3_compressed_Captura-de-tela-2026-07-21-165752.webp"
                  alt="Comida baiana tradicional"
                  className="w-full h-auto object-cover aspect-[4/3]"
                  loading="lazy"
                />
                <div className="absolute bottom-4 left-4 bg-yellow-500 text-white text-xs font-semibold px-3 py-1.5 rounded-full">
                  Rua 8 de Setembro, 1444 - Varjota, Fortaleza - CE, 60175-210
                </div>
              </div>
            </div>

            {/* Text */}
            <div className="reveal reveal-right">
              <span className="inline-block text-gold-500 text-xs font-semibold tracking-widest uppercase mb-3">
                NOSSA HISTÓRIA
              </span>
              <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown-900 leading-tight mb-6">
                O sabor da Bahia em clima de buteco <span className="text-gold-500">cearense</span>
              </h2>
              <p className="text-brown-600 text-base md:text-lg leading-relaxed mb-8">
                O Buteco do Baiano é um bar e restaurante localizado na Varjota, em Fortaleza, que oferece culinária baiana, nordestina, petiscos, drinks e música ao vivo. Um lugar para comer bem, beber, conversar e aproveitar um ambiente descontraído.
              </p>

              {/* Highlights */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
                {highlights.map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-gold-500/10 text-gold-500 flex-shrink-0">
                      <Check size={14} />
                    </span>
                    <span className="text-brown-700 text-sm font-medium">{item}</span>
                  </div>
                ))}
              </div>

              {/* Feature cards */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {features.map((f) => (
                  <div
                    key={f.title}
                    className="bg-white rounded-xl p-4 text-center shadow-sm hover:shadow-md transition-shadow duration-300"
                  >
                    <div className="text-2xl mb-2">{f.icon}</div>
                    <p className="text-brown-800 text-xs font-semibold">{f.title}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}